import { ConfirmationDialog, ErpDataTableV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';
import { ActionBar, LotDialog } from './components';
import type { Lo, LoInput } from '@/types/schemas';
import { usePathname, useRouter } from '@/routing';
import { useCRUD, useFormState } from '@/hooks';
import { QUERY_KEYS } from '@/constants';

export default function LoHang() {
  const router = useRouter();
  const pathName = usePathname();

  const { addItem, updateItem, deleteItem, refreshData, isLoading, data } = useCRUD<Lo, LoInput>({
    endpoint: QUERY_KEYS.LO
  });

  const {
    showForm,
    showDelete,
    selectedObj,
    selectedRowIndex,
    formMode: mode,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useFormState<Lo>();

  const handleSubmit = async (data: LoInput) => {
    try {
      if (mode === 'add') {
        await addItem(data);
      } else if (mode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, data);
      }
      handleCloseForm();
      clearSelection();
    } catch {
      return;
    }
  };

  const handleTabChange = (tabPath: string) => {
    if (tabPath === pathName) return;
    router.push(`/danh-muc/vat-tu-san-pham-va-kho/${tabPath}`);
  };

  const tables = [
    {
      name: 'Vật tư, sản phẩm',
      rows: [],
      columns: [],
      value: 0
    },
    {
      name: 'Lô hàng',
      rows: data,
      columns: getDataTableColumns(),
      value: 1
    },
    {
      name: 'Kho hàng',
      rows: [],
      columns: [],
      value: 2
    },
    {
      name: 'Vị trí kho hàng',
      rows: [],
      columns: [],
      value: 3
    }
  ];

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {showForm && (
        <LotDialog
          mode={mode}
          open={showForm}
          onClose={handleCloseForm}
          onAddButtonClick={handleAddClick}
          onEditButtonClick={handleEditClick}
          onCopyButtonClick={handleCopyClick}
          onDeleteButtonClick={handleDeleteClick}
          onSubmit={handleSubmit}
          initialData={mode === 'add' && !isCopyMode ? undefined : (selectedObj ?? undefined)}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddIconClick={handleAddClick}
          onEditIconClick={handleEditClick}
          onDeleteIconClick={handleDeleteClick}
          onCopyIconClick={handleCopyClick}
          onWatchIconClick={handleViewClick}
          onRefreshClick={refreshData}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          defaultTabIndex={1}
          onTabChange={(_, value: number) => {
            const tabPaths = ['vat-tu-san-pham', 'lo-hang', 'kho-hang', 'vi-tri-kho-hang'];
            handleTabChange(tabPaths[value]);
          }}
          loading={isLoading}
        />
      </div>

      {showDelete && (
        <ConfirmationDialog
          open={showDelete}
          onClose={handleCloseDelete}
          onConfirm={() => {
            deleteItem(selectedObj!.uuid);
            handleCloseDelete();
            clearSelection();
            handleCloseForm();
          }}
        />
      )}
    </div>
  );
}
